/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/EntityState/Active/Post
 * @desc Active node component for EntityState
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { EntityState } from 'labstep-web/models/entity-state.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';

export const FilterPostNewIndexEntityStateActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'entityState',
  );

  const { guid: guidAttribute } = filter.getAttributeValues(node);

  const guid = guidAttribute?.value;

  if (!guid) {
    return null;
  }

  return (
    <EntityReadEntityContainer
      entityName={EntityState.entityName}
      id={guid}
    >
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <RemoveLabel
            icon={ICONS.entity_state.primary}
            name={entity.name}
            onRemoveClick={onRemoveClick}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};
